import styled from "styled-components";

export const IconButtonRoot = styled.button`
  border: none;
  background: transparent;
  padding: 0.5rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: inherit;
  outline: none;
  font: inherit;
`;

export const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4em;
  color: #999;
`;
